var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],ref:"contextmenu",staticClass:"contextmenu",style:({
    left: _vm.containerParam.left + 'px',
    top: _vm.containerParam.top + 'px',
  })},[_c('div',{staticClass:"item"}),_c('div',{staticClass:"item"},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"size":"mini","type":"primary","class-name":"hl_miniBtn"},on:{"click":function($event){return _vm.detail($event)}}},[_vm._v("按钮")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }